import React from "react";
import ReportItemEntityListRow from "./ReportItemEntityListRow";

export default function MonoTextuaryEntity({ entity, children }) {
  return (
    <div className="report-scheme-report-item-row">
      <ReportItemEntityListRow entity={entity} itemName="Metinsel" />
      {children && children}
    </div>
  );
}
